import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Tile from 'components/product/Tile';
import List from 'components/product/List';
import RenderRichText from 'utils/richText/renderRichText';
import ArrowButton from 'components/buttons/ArrowButton';

import { StyledBenefitsWrapper, StyledBenefitsTextWrapper, StyledBenefitsImageWrapper } from 'components/product/styled';

const isFR = process.env.LANG_CODE === 'fr-fr';

function ProductSection({ slice, uid }) {
  const [ shouldShowAllItem, showAllItems ] = useState(false)
  const sectionImage = slice.primary.section_image.url;
  const sectionHeading = slice.primary.section_heading.raw;
  const isLogo = slice.primary.privatefly_logo;
  const isJetCardPage = uid.includes("jet-card")

  return (
    <StyledBenefitsWrapper>
      
      <StyledBenefitsTextWrapper>
        {sectionHeading && <RenderRichText richTextArray={sectionHeading} /> }

        <StyledBenefitsImageWrapper isLogo={isLogo} isMobile={true}>
          <img src={sectionImage} />
        </StyledBenefitsImageWrapper>

        <List listItems={slice.items} shouldShowAllItem={shouldShowAllItem} />
        <ArrowButton 
          buttonText={shouldShowAllItem ? isFR ? "FERMER" : "CLOSE" : slice.primary.featured_button_text } 
          buttonHref="link"
          theme="red"
          onClick={() => showAllItems(!shouldShowAllItem)}
          isLink={false}
        /> 
      </StyledBenefitsTextWrapper>

      <StyledBenefitsImageWrapper isLogo={isLogo} isJetCardPage={isJetCardPage}>
        <img src={sectionImage} />
      </StyledBenefitsImageWrapper>

    </StyledBenefitsWrapper>
  )
}

ProductSection.propTypes = {
  slice: PropTypes.object,
  uid: PropTypes.string
}

export default ProductSection

